import { createAsyncAction } from 'redux-promise-middleware-actions';

import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const usersPermissionsConstants = {
    USERS_PERMISSIONS_LOADED: 'USERS_PERMISSIONS_LOADED',
    USER_PERMISSION_CREATED: 'USER_PERMISSION_CREATED',
    USER_PERMISSION_UPDATED: 'USER_PERMISSION_UPDATED',
    USER_PERMISSION_DELETED: 'USER_PERMISSION_DELETED'
};

export const usersPermissionsFulfilledConstants = getActionTypesResult(usersPermissionsConstants, '_FULFILLED');
export const usersPermissionsRejectedConstants = getActionTypesResult(usersPermissionsConstants, '_REJECTED');
export const usersPermissionsPendingConstants = getActionTypesResult(usersPermissionsConstants, '_PENDING');

export const fetchUsersPermissions = createAsyncAction(usersPermissionsConstants.USERS_PERMISSIONS_LOADED, () =>
    api.get(`userGeography/getByFilter`).then(res => res.data)
);

export const createUserPermission = createAsyncAction(
    usersPermissionsConstants.USER_PERMISSION_CREATED,
    userPermission => api.post(`userGeography/create`, userPermission).then(res => res.data)
);

export const updateUserPermission = createAsyncAction(
    usersPermissionsConstants.USER_PERMISSION_UPDATED,
    (userId, userPermission) => api.put(`userGeography/${userId}/edit`, userPermission).then(res => res.data)
);

export const deleteUserPermission = createAsyncAction(usersPermissionsConstants.USER_PERMISSION_DELETED, userId =>
    api.delete(`userGeography/${userId}/delete`).then(() => userId)
);
